import * as yup from 'yup';

import { getRequiredField } from 'src/utils';

export const schema = yup.object().shape({
  display_name: yup.string().required(getRequiredField).nullable(),
});
